import dayjs from 'dayjs';

export const formatDateInSentence = (sentence: string) => {
  const regex = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/;

  const match = sentence.match(regex);

  if (match) {
    const formattedDate = dayjs(new Date()).format('DD.MM.YYYY HH:mm');

    return sentence.replace(regex, formattedDate);
  }

  return sentence;
};
